/**
 * @generated SignedSource<<ad5de5a35d88e9b583fd972e12939103>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraConfigStateConfigurationStatus = "CONFIGURED" | "NOT_CONFIGURED" | "NOT_INSTALLED" | "NOT_SET" | "PARTIALLY_CONFIGURED" | "PROVIDER_ACTION_CONFIGURED" | "PROVIDER_ACTION_NOT_CONFIGURED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type manage_IntegrationsConfigStates$data = ReadonlyArray<{
  readonly node: {
    readonly appDisplayName: string | null | undefined;
    readonly appIconLink: string | null | undefined;
    readonly config: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly configureLink: string | null | undefined;
          readonly status: JiraConfigStateConfigurationStatus | null | undefined;
        } | null | undefined;
      }>;
    };
    readonly id: string;
  };
  readonly " $fragmentType": "manage_IntegrationsConfigStates";
}>;
export type manage_IntegrationsConfigStates$key = ReadonlyArray<{
  readonly " $data"?: manage_IntegrationsConfigStates$data;
  readonly " $fragmentSpreads": FragmentRefs<"manage_IntegrationsConfigStates">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "manage_IntegrationsConfigStates",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraAppConfigState",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "id"
            },
            "action": "THROW",
            "path": "node.id"
          },
          {
            "kind": "ScalarField",
            "name": "appDisplayName"
          },
          {
            "kind": "ScalarField",
            "name": "appIconLink"
          },
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraConfigStateConnection",
              "kind": "LinkedField",
              "name": "config",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "JiraConfigStateEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraConfigState",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "status"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "configureLink"
                          }
                        ]
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "node.config.edges"
                }
              ]
            },
            "action": "THROW",
            "path": "node.config"
          }
        ]
      },
      "action": "THROW",
      "path": "node"
    }
  ],
  "type": "JiraAppConfigStateEdge"
};

(node as any).hash = "7cb1e047b6ee7509035df408cbe31ce3";

export default node;
